import { CollectionElement } from '@typedream/core';
import { getPageIDToPath, ICollectionPageData, ISpaceRoute } from '@typedream/data';
import { setNodes, withoutNormalizing } from '@udecode/plate-core';
import { Element } from 'slate';
import { DreamWithOverride } from '../../plate';
import { ELEMENT_COLLECTION } from '../../pluginKeys';
import updateCollection from '../../utils/updateCollection';
import { BLOCK_ELEMENT_KEY } from './components/CollectionDataElement/types';
import {
  CollectionPluginOptions, ICollectionCursorState, ICollectionData, ICollectionEditor,
} from './types';

export const withCollection: DreamWithOverride<CollectionPluginOptions> = (editor, { options }) => {
  const { getItemPageDataID } = options;
  const e = editor as ICollectionEditor;
  const { normalizeNode } = editor;
  e.collectionCursors = {};

  // TODO: Complete these functions
  e.setspaceCollectionData = (spaceCollData: ICollectionPageData) => {
    e.spaceCollData = spaceCollData;
  };
  e.setspaceRoutes = (routes: ISpaceRoute) => {
    e.routes = routes;
  };

  e.synchronizeCollection = (
    pageCollData: ICollectionData,
    elementID?: string,
  ) => {
    if (e.spaceCollData && e.routes) {
      const pagesPaths = getPageIDToPath(e.routes, [], {});

      if (pageCollData && e.children && Array.isArray(e.children)) {
        const newChildren = updateCollection(
          pageCollData,
          e.spaceCollData,
          pagesPaths,
          getItemPageDataID,
          elementID,
        )({ id: undefined, children: JSON.parse(JSON.stringify(e.children)) } as any);

        withoutNormalizing(e, () => {
          e.children = newChildren.children;
          e.onChange();
        });
      }
    } else {
      setTimeout(() => e.synchronizeCollection(pageCollData, elementID), 100);
    }
  };

  e.setCursorState = (elementID: string, cursorState: ICollectionCursorState) => {
    const newState = { ...e.collectionCursors };
    newState[elementID] = cursorState;
    e.collectionCursors = newState;
  };

  e.getCursorState = (
    elementID: string,
  ): ICollectionCursorState => e.collectionCursors?.[elementID];

  e.normalizeNode = async (entry) => {
    const [node, path] = entry;
    if (
      Element.isElement(node)
      && node.type === ELEMENT_COLLECTION
      && (node as CollectionElement)[BLOCK_ELEMENT_KEY.COLLECTION_DATA_ID]
      && (node as CollectionElement)[BLOCK_ELEMENT_KEY.COLLECTION_DATA_ID] !== node.id
    ) {
      // This element is a result of Duplicate, where it got a new ID,
      // but the COLLECTION_DATA_ID remains the old one from duplicated element

      // 1. Insert new connectionDataID in page customization
      // await duplicateCollectionData(node[BLOCK_ELEMENT_KEY.COLLECTION_DATA_ID], node.id);
      // 2. Update the COLLECTION_DATA_ID to the current id
      setNodes(
        e,
        {
          [BLOCK_ELEMENT_KEY.COLLECTION_DATA_ID]: node.id,
        },
        { at: path },
      );
      return;
    }
    normalizeNode(entry);
  };
  return e;
};
